import { fetchApiLogsApi } from "../../../../api/ViewproductApi";
import { useEffect, useState } from "react";
import CustomTable from "../../../controls/CustomTable";
import Loading from "../../../controls/Loading";

const ProductApiLogs = ({ productData }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    

    useEffect(() => {

        fetchData(productData.key);
    }, []);

    const fetchData = async (productId) => {
        setLoading(true); // Start loading
        try {
            const data = await fetchApiLogsApi(productId);
            console.log("data in Api Log ", data);
            setData(data.apiLogs);
        } catch (error) {
            toast.error("Failed to load data !");
        } finally {
            setLoading(false); // Stop loading
        }
    };

    // Columns for the table
    const columns = [
        { field: "Date", headerName: "Date & Time" },
        { field: "ActionBy", headerName: "Action Performed" },
        { field: "Log", headerName: "Payload" },
        { field: "Response", headerName: "Response" }
    ];


 
  const rows = data.map((item) => ({
  Date: new Date(item?.ActtionOn?._seconds || item?.ActtionOn?.seconds * 1000).toString().substring(0, 24),
  ActionBy:item?.ActionBy,
  Log:JSON.stringify(item?.Log),
  Response:JSON.stringify(item?.Response)
  }));
    return (
        <>
            <div className="w-full p-4 ">  <CustomTable columns={columns} rows={rows}  showTextOnRows={rows.length=="0" ? "No Data Available !" : null} loading={loading} />
             
            </div>
        </>
    );
};

export default ProductApiLogs;
